import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Plus, Minus } from "lucide-react";
import { motion, AnimatePresence } from "framer-motion";
import { Overline } from "@/components/motion";
import { getFaqs } from "@/lib/api";

export default function HomeFaq({ title, subtitle }) {
  const [faqs, setFaqs] = useState([]);
  const [open, setOpen] = useState(0);
  useEffect(() => {
    getFaqs().then((d) => setFaqs(d.slice(0, 6))).catch(() => {});
  }, []);

  if (!faqs.length) return null;

  return (
    <section id="faq" data-testid="home-faq" className="relative py-24 sm:py-32 bg-[#fdfbf7]">
      <div className="max-w-[1400px] mx-auto px-5 sm:px-8 grid grid-cols-1 lg:grid-cols-12 gap-12">
        <div className="lg:col-span-4">
          <Overline>{title || "Good to Know"}</Overline>
          <h2 className="font-serif text-[#3b1a1a] text-4xl sm:text-5xl leading-[1.05] tracking-tight mt-5">
            Your questions, <span className="italic text-[#7c1d1d]">answered.</span>
          </h2>
          <p className="text-[#5a4b4b] mt-5 leading-relaxed">{subtitle || "Everything travellers ask before their India journey."}</p>
          <Link to="/faq" className="mt-6 inline-flex text-xs tracking-[0.24em] uppercase text-[#7c1d1d]">All FAQs →</Link>
        </div>

        <div className="lg:col-span-8 border-t border-[#d4af37]/25">
          {faqs.map((f, i) => (
            <div key={f.id} className="border-b border-[#d4af37]/25">
              <button data-testid={`faq-toggle-${i}`} onClick={() => setOpen(open === i ? -1 : i)} className="w-full flex items-center justify-between gap-6 py-6 text-left group">
                <span className="font-serif text-xl sm:text-2xl text-[#3b1a1a] group-hover:text-[#7c1d1d] transition-colors">{f.question}</span>
                <span className="shrink-0 w-9 h-9 border border-[#7c1d1d]/40 grid place-items-center text-[#7c1d1d]">
                  {open === i ? <Minus className="w-4 h-4" /> : <Plus className="w-4 h-4" />}
                </span>
              </button>
              <AnimatePresence initial={false}>
                {open === i && (
                  <motion.div initial={{ height: 0, opacity: 0 }} animate={{ height: "auto", opacity: 1 }} exit={{ height: 0, opacity: 0 }} transition={{ duration: 0.35 }} className="overflow-hidden">
                    <p className="pb-6 text-[#5a4b4b] leading-relaxed max-w-2xl">{f.answer}</p>
                  </motion.div>
                )}
              </AnimatePresence>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
